import React from 'react'

import clsx from 'clsx'

import Paper from 'components/Paper'
import ReviewMethodologyModal from 'components/ReviewMethodologyModal'
import Typography from 'components/Typography'
import { thousandSeparator } from 'helpers/formatters'

import BarChart from '../charts/BarChart'
import DiamondsChart from '../charts/DiamondsChart'
import DonutChart from '../charts/DonutChart'

import classes from './UsersAndUseCases.module.scss'

/** @type {import("./types").default} */
const UsersAndUseCases = ({ className, listingName, charts, totalReviews, ...props }) => {
  const { company_sizes, top_industries, use_cases } = charts || {}

  return (
    <Paper className={clsx('UsersAndUseCases', classes.root, className)} {...props}>
      <div className={classes.heading}>
        <Typography component="h2" variant="title-4">
          Who uses {listingName}?
        </Typography>

        <Typography component="p" variant="body-xs">
          Based on {thousandSeparator(totalReviews)} verified user reviews.{' '}
          <ReviewMethodologyModal
            targetComponent="product_users-and-use-cases"
            linkText="Learn more"
            className={classes.learnMoreLink}
          />
        </Typography>
      </div>
      <div className={classes.content}>
        <BarChart data={company_sizes} />
        <DonutChart data={top_industries} />
        <DiamondsChart data={use_cases} />
      </div>
    </Paper>
  )
}
export default UsersAndUseCases
